module.exports = __webpack_public_path__ + "static/media/MosesPart2.ea18f5b6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/Moses/MosesPart2.mp3
// module id = 150
// module chunks = 0